import {endOfMonth, endOfWeek, startOfMonth, startOfWeek, subDays, subMonths} from "date-fns";
import {ShortcutRange} from "../../interfaces/datepicker/datepicker";

export const SHORTCUT_RANGES: ShortcutRange[] = [
    {
        label: "date_picker_today",
        range: {
            startDate: new Date(),
            endDate: new Date()
        }
    },
    {
        label: "date_picker_yesterday",
        range: {
            startDate: subDays(new Date(), 1),
            endDate: subDays(new Date(), 1)
        }
    },
    {
        label: "date_picker_current_month",
        range: {
            startDate: startOfMonth(new Date()),
            endDate: endOfMonth(new Date())
        }
    },
    {
        label: "date_picker_last_week",
        range: {
            startDate: startOfWeek(subDays(new Date(), 7), {weekStartsOn: 1}),
            endDate: endOfWeek(subDays(new Date(), 7), {weekStartsOn: 1})
        }

    },
    {
        label: "date_picker_last_two_weeks",
        range: {
            startDate: startOfWeek(subDays(new Date(), 14), {weekStartsOn: 1}),
            endDate: endOfWeek(subDays(new Date(), 7), {weekStartsOn: 1})
        }
    },
    {
        label: "date_picker_last_month",
        range: {
            startDate: startOfMonth(subMonths(new Date(), 1)),
            endDate: endOfMonth(subMonths(new Date(), 1))
        }
    }
]
